import { Dispatch, SetStateAction } from 'react'
import { useForm } from 'react-hook-form'
import { Error, Symbol, Spinner } from 'ui'
import clsx from 'clsx'

type Props = {
	designName: string
	isEditingName: boolean
	loading: boolean
	errorMessage: string
	setIsEditingName: Dispatch<SetStateAction<boolean>>
	updateName: (values: { designName: string }) => void
	readOnly?: boolean
	renderLabel?: boolean
	className?: string
}

export default function OrderName({
	designName,
	isEditingName,
	loading,
	setIsEditingName,
	updateName,
	readOnly = false,
	renderLabel = false,
	className
}: Props) {
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({})

	return (
		<div className={`mb-2 w-full max-sm:mt-3 ${className ?? ''}`}>
			{renderLabel ? (
				<span className="text-[13px] text-g-500 -mb-2.5 block z-10 relative">Order name</span>
			) : null}
			{isEditingName ? (
				<>
					<form
						onSubmit={handleSubmit(updateName)}
						className="flex justify-betweeen items-center space-x-4 pb-1 border-b-px min-h-[65px]">
						<input
							className="desktop-h3 font-serif w-full focus:outline-none"
							defaultValue={designName}
							autoFocus
							{...register('designName', { required: true })}
						/>

						<div className="flex gap-2 items-center">
							<button
								className="hyperlink h-fit text-sm mt-2"
								onClick={() => setIsEditingName(false)}>
								Cancel
							</button>
							<button className="button button-dark text-[13px]" type="submit" disabled={loading}>
								{loading && <Spinner />}
								Save
							</button>
						</div>
					</form>
					{errors.designName && <Error>Design name can't be empty</Error>}
				</>
			) : (
				<button
					className={clsx(
						'flex group items-center space-x-3 pb-1 min-h-[65px] text-left transition-colors duration-300',
						{
							'border-b border-transparent hover:border-g-200': !readOnly
						}
					)}
					disabled={readOnly}
					onClick={() => setIsEditingName((prevState) => !prevState)}>
					<h2 className="design-name desktop-h3">{designName}</h2>
					{!readOnly && (
						<div className="iconButton group-hover:opacity-50 h-7 w-7 aspect-square">
							<Symbol id="pencil" className="text-[13px]" />
						</div>
					)}
				</button>
			)}
		</div>
	)
}
